import { useLingui } from '@lingui/react/macro';

import { DesktopEntityFilter } from '@/components/SharedFilters/EntityFilter/DesktopEntityFilter';
import IconStoreRepair from '@/icons/StoreRepair.svg';

import { useFilters } from '../FiltersState';

export const FiltersWorkshop = ({ tag }: { tag?: boolean }) => {
  const { t } = useLingui();

  const {
    workshops: { workshops, setWorkshops },
  } = useFilters();

  const selectedWorkshopsCount = workshops.length;

  return (
    <DesktopEntityFilter
      selectedEntities={workshops}
      setSelectedEntities={setWorkshops}
      traits={['workshop']}
      tag={tag}
      label={t({ id: 'requests.filters.workshop.label', message: 'Workshop' })}
      searchPlaceholder={t({
        id: 'requests.filters.workshop.search.label',
        message: 'Search workshops',
      })}
      icon={<IconStoreRepair />}
      tagSelectedCountLabel={t({
        id: 'requests.filters.workshop.multiple',
        message: `${selectedWorkshopsCount} workshops`,
      })}
    />
  );
};
